import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';

import CaseOxygens from './CaseOxygens.vue';
import queries from '~lib/common/queries/Oxygen';

const enhance = compose(
  dataView({ queries }),
  renameProps({ data: 'oxygens' }),
);

export default enhance(CaseOxygens);
